import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';
import { PreparationsService } from 'src/app/services/catalogs-services/preparations-services/preparations.service';
import { tap } from 'rxjs/internal/operators/tap';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';
import { MatDialog } from '@angular/material';
import { empty } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-catalogs-new-preparation-creation-card',
  templateUrl: './catalogs-new-preparation-creation-card.component.html',
  styleUrls: ['./catalogs-new-preparation-creation-card.component.scss']
})
export class CatalogsNewPreparationCreationCardComponent implements OnInit, OnDestroy {

  imageUrl: string;

  showButton;
  basicDataForm = new FormGroup({
    active: new FormControl(true, Validators.required),
    name: new FormControl(null, Validators.required),
    code: new FormControl(null, Validators.required)
  });
  addNewPreparationSubscription: Subscription;

  constructor(private spinnerService: SpinnerService,
              private snackbarService: SnackBarService,
              private dialog: MatDialog,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private preparationsService: PreparationsService) {
                this.showButton = true;
              }

  ngOnInit() {
  }

  public addNewPreparation() {
    this.showButton = false;
    this.spinnerService.show('preparations-new-spinner');

    const validation = this.validateForm();
    if (validation === true) {
      this.addNewPreparationSubscription = this.preparationsService.addNewPreparation(this.imageUrl, this.basicDataForm).pipe(
        tap(o => this.snackbarService.open('catalogs-page.snackbar messages.add preparation success', 'success')),
        tap(o => this.spinnerService.hide('preparation-new-spinner')),
        tap(o => this.router.navigate(['/catalog/preparations'], { relativeTo: this.activatedRoute })),
        catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); this.showButton = true; this.spinnerService.hide('preparation-new-spinner'); return empty();})
      ).subscribe();
    } else {
      this.showButton = true;
      this.spinnerService.hide('preparations-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.imageUrl) {
      return 'catalogs-page.snackbar messages.image preparations error';
    } else if (!this.basicDataForm.get('name').valid) {
      return 'catalogs-page.snackbar messages.name preparations error';
    } else if (!this.basicDataForm.get('code').valid) {
      return 'catalogs-page.snackbar messages.code preparations error';
    } else {
      return true;
    }
  }

  public cancelPreparation() {
    this.router.navigate(['/catalog/preparations'], { relativeTo: this.activatedRoute });
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.imageUrl = result[0].Url;
        }
      });
  }

  ngOnDestroy() {
    if (this.addNewPreparationSubscription) { this.addNewPreparationSubscription.unsubscribe(); }
  }
}
